<div class="container mt-4">
  <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a href="javascript:void(0)" (click)="goToHome()">Home</a><span class="separator">/</span></li>
      <li class="breadcrumb-item active"><a href="javascript:void(0)">Lista pagamenti</a></li>
    </ol>
  </nav>
</div>

<div class="container">
  <h4 class="fw-bold d-flex justify-content-center mt-3">Lista pagamenti</h4>
  <form [formGroup]="formFilter" class="d-flex justify-content-end">
    <div class="d-flex justify-content-end container-fluid">
      <button class="btn btn-primary primary-button btn-icon" data-bs-toggle="dropdown">
        <svg class="icon icon-white ms-1">
          <use href="./content/svg/sprites.svg#it-funnel"></use>
        </svg>
        <span><span jhiTranslate="istanze.filtra.titolo">Filtra</span><span *ngIf="countFiltri != 0"> ({{ countFiltri }})</span></span>
      </button>
      <div class="dropdown-menu dismissible w-50" role="menu">
        <div class="container-fluid my-2">
          <div class="row justify-content-between mb-2">
            <div class="col">
              <h5 class="fw-bold">Filtra ricerca</h5>
            </div>
            <div class="col">
              <button type="button" class="btn-close float-end" data-bs-dismiss="menu"
                      aria-label="Chiudi avviso"></button>
            </div>
          </div>
          <div class="row mb-3 mt-3">
            <div class="col-lg-12">
              <div class="select-wrapper">
                <label for="tributo">Tributo</label>
                <select id="tributo">
                  <option selected="" value="">Tutti i tributi</option>
                  <option value="LV">Lampade Votive</option>
                  <option value="IM">IMU</option>
                  <option value="TB">Rifiuti</option>
                  <option value="TX">Tasi</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-4 mb-1">
              <button class="btn btn-primary primary-button btn-xs btn-me w-100" type="button"
                      (click)="getPaymentNotices()">
                <span>Applica</span>
              </button>
            </div>
            <div class="col-lg-4 mb-1">
              <button class="btn btn-danger btn-xs btn-me w-100" type="button"
                      (click)="$event.stopPropagation();removeFilters()">
                <span>Rimuovi</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div class="mt-2 mb-2">
    <div class="container-fluid my-2 text-center" style="min-height: 400px" *ngIf="paymentNoticesResponse && paymentNoticesResponse.mandatiPagamento && this.paymentNoticesResponse.mandatiPagamento.length !== 0">
      <div class="card-wrapper mt-3 d-flex justify-content-center" style="padding-bottom: 0; ">
        <div class="card card-bg border-bottom-card background-primary-before" >
          <div class="card-body">
            <div class="table-responsive ">
              <table class="table table-striped ">
                <caption hidden>Elenco istanze</caption>
                <thead>
                <tr>
                  <th scope="col">Numero</th>
                  <th scope="col">Anno</th>
                  <th scope="col">Tributo</th>
                  <th scope="col">Importo totale</th>
                  <th scope="col" jhiTranslate="istanze.descrizione">Descrizione</th>
                  <th scope="col" jhiTranslate="istanze.stato">Stato</th>
                  <th scope="col" jhiTranslate="istanze.azioni">Azioni</th>
                </tr>
                </thead>
                <tbody *ngIf="paymentNoticesResponse.mandatiPagamento.length">
                <tr *ngFor="let pg of paymentNoticesResponse.mandatiPagamento; index as i">
                  <td>{{pg.Numero ?? '-'}}</td>
                  <td>{{pg.Anno}}</td>
                  <td>{{pg.Tributo}}</td>
                  <td>{{pg.Importo | currency: 'EUR'}}</td>
                  <td>{{pg.Descrizione ?? '-'}}</td>
                  <td>{{pg.stato}}</td>
                  <td class="fw-bold">
                    <div>
                      <a title="Paga"
                         (click)="goToPagamento(pg)">
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-primary grow" id="Icons"
                             viewBox="0 0 32 32">
                          <style type="text/css">
                            .st0 {
                              fill: none;
                              stroke: #06c;
                              stroke-width: 2;
                              stroke-linecap: round;
                              stroke-linejoin: round;
                              stroke-miterlimit: 10;
                            }

                            .st3 {
                              fill: none;
                            }
                          </style>
                          <path class="st0"
                                d="M19.7,26.8c-0.9-0.9-1.1-2.2-0.7-3.3l-3.3-3.3c-1.6-1.6-1.5-4.4,0.3-6.2l0,0l5,5"/>
                          <path class="st0" d="M12.7,26.3c0.6,0.7,1.3,1.3,2.1,1.7c0.7,0.4,1.2,1.2,1.2,2v0"/>
                          <path class="st0" d="M18,24H8c-1.1,0-2-0.9-2-2V5c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2v13"/>
                          <line class="st0" x1="10" y1="3" x2="10" y2="24"/>
                          <line class="st0" x1="16" y1="6" x2="16" y2="10"/>
                          <path class="st0" d="M25,30v-9.5c0-3.3-2-6.2-5-7.4"/>
                          <rect x="-144" y="-216" class="st3" width="536" height="680"/>
                        </svg>
                      </a>
                      <!--<a title="Modifica Bozza">
                        <svg class="icon icon-primary grow"
                             *ngIf="ist.stato.codice == '00'"
                             (click)="goToBozza(ist.servizio.cdServizio ?? '')">
                          <use href="./content/svg/sprites.svg#it-pencil"></use>
                        </svg>
                      </a>
                      <a title="Elimina Bozza">
                    <span data-bs-toggle="modal" data-bs-target="#modalDeleteIstanza"
                          (click)="setClickedIstanza(ist.id)"><svg class="icon grow"
                                                                   *ngIf="ist.stato.codice == '00'"><use
                      href="./content/svg/sprites.svg#it-delete"></use></svg></span>
                      </a>
                      <a title="Visualizza integrazioni">
                        <svg class="icon icon-primary grow"
                             *ngIf="ist.stato.codice !== '00'"
                             (click)="goToDettaglioIstanza(ist.id)">
                          <use href="./content/svg/sprites.svg#it-search"></use>
                        </svg>
                      </a> -->
                    </div>
                  </td>
                  <br *ngIf="windowSize <= 768">
                </tr>
                </tbody>
              </table>
              <div class="position-absolute end-0 mx-4 my-2 no-border">
                <div class="bootstrap-select">
                  <label class="t-primary text-small" *ngIf="windowSize >= 768" jhiTranslate="pagina.elementi">Elementi
                    per pagina:</label>
                  <select id="defaultSelect" formControlName="numEl" class="t-primary text-center" style="border: none">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>
              <!--<nav class="pagination-wrapper justify-content-center pagination-total"
                   aria-label="Esempio di navigazione responsive della pagina" *ngIf="this.paymentNoticesResponse?.mandatiPagamento.length !== 0 && !loading">
                <ul class="pagination justify-content-center">
                  <li class="page-item" [ngClass]="{'disabled c-normal': Isfirst === 'true'}">
                    <a class="page-link" (click)="paginaPrecedente()">
                      <svg class="icon icon-primary icon-color">
                        <use href="./content/svg/sprites.svg#it-chevron-left"></use>
                      </svg>
                      <span class="visually-hidden">Pagina precedente</span>
                    </a>
                  </li>
                  <li class="page-item d-none d-sm-flex" *ngFor="let p of [].constructor(Totalpages); index as i"
                      (click)="paginaCorrente != i ?vaiAPagina(i) : ''">
                    <a class="page-link"
                       [ngClass]="{'border primary-border text-color': paginaCorrente == i}">{{i + 1 }}</a>
                  </li>
                  <li class="page-item" [ngClass]="{'disabled c-normal': Islast === 'true'}">
                    <a class="page-link" (click)="paginaSuccessiva()">
                      <span class="visually-hidden">Pagina successiva</span>
                      <svg class="icon icon-primary icon-color">
                        <use href="./content/svg/sprites.svg#it-chevron-right"></use>
                      </svg>
                    </a>
                  </li>
                </ul>
                <p jhiTranslate="pagina.items" [translateValues]="{ total: Totalelement }">Totale {{Totalelement}}
                  elementi </p>
              </nav> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
